import type { Project } from './types'

export type ProjectSortKey = 'focus' | 'name' | 'type' | 'flow' | 'stage' | 'description' | 'status' | 'targetDate'
export type ProjectSort = { key: ProjectSortKey; direction: 'asc' | 'desc' }

const text = (value: unknown) => String(value ?? '').trim()
const compareText = (left: unknown, right: unknown) => {
  const a = text(left)
  const b = text(right)
  return a.localeCompare(b, 'zh-TW', { numeric: true, sensitivity: 'base' })
}

function valueFor(row: Project, key: ProjectSortKey): string | number | boolean {
  if (key === 'name') return `${row.groupName} ${row.name}`.trim()
  if (key === 'flow' || key === 'stage') return row.stage
  return row[key]
}

export function sortProjects(rows: Project[], sort: ProjectSort | null) {
  if (!sort) return rows
  const direction = sort.direction === 'asc' ? 1 : -1
  return [...rows].sort((left, right) => {
    const a = valueFor(left, sort.key)
    const b = valueFor(right, sort.key)
    if (typeof a === 'string' && typeof b === 'string') {
      if (!a.trim() && !b.trim()) return left.sortOrder - right.sortOrder
      if (!a.trim()) return 1
      if (!b.trim()) return -1
    }
    const compared = typeof a === 'number' && typeof b === 'number'
      ? a - b
      : typeof a === 'boolean' && typeof b === 'boolean'
        ? Number(a) - Number(b)
        : compareText(a, b)
    return compared * direction || left.sortOrder - right.sortOrder || left.id.localeCompare(right.id)
  })
}
